/** 기기·분류 차트에 쓰는 색. 여러 섹션이 같은 순서를 공유한다 */
export const deviceColors = ['#3B82F6', '#10B981', '#F59E0B']
